<script context="module">

    export function l10n(chapter, text){
        return text;
    }

    export function l(text){
        return text;
    }
</script>